module.exports = __webpack_public_path__ + "static/media/system_flow_credit_check.00ecb333.svg";